import api from './api';
import { ApiResponse, unwrapApiResponse } from '@/utils/api-response.util';
import { BadgesState } from '@/types/updates-hub';

class UpdatesHubService {
  /**
   * Отримання початкового стану лічильників (Badges)
   * Викликається при старті додатку та при поверненні з background.
   */
  async getBadges(): Promise<BadgesState> {
    const response = await api.get<ApiResponse<BadgesState>>('/updates-hub/badges');
    return unwrapApiResponse<BadgesState>(response);
  }
}

export const updatesHubService = new UpdatesHubService();
